// extracted by mini-css-extract-plugin
export default {"root":"BackButton_root__+A5yf","backButtonOverride":"BackButton_backButtonOverride__XSQQr"};